import { FC } from 'react';

import { EStatisticType } from 'views/Statistics/StatisticsView.types';

import {
  getDescriptiveLabelFromDate,
  getFormattedValueByType
} from 'components/AnalyticsBox/utils';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';

type AttributeTrendsTooltipProps = {
  active?: boolean;
  payload?: any[];
  label?: string;
  metricType: EStatisticType;
  colors: { [key: string]: string };
};

export const AttributeTrendsTooltip: FC<AttributeTrendsTooltipProps> = ({
  active,
  payload,
  label,
  metricType,
  colors
}) => {
  const renderTrendsSeparator = () => {
    return (
      <div className="w-full border-t border-dashed border-zinc-300 my-1"></div>
    );
  };

  if (active && payload && payload.length) {
    return (
      <Card className="flex flex-col py-2 px-4 items-start gap-1 rounded-md border border-base-popover bg-base-popover shadow-md">
        <CardHeader className="p-0">
          <CardTitle className="text-base-popoverForeground">
            {label ? getDescriptiveLabelFromDate(label) : ''}
          </CardTitle>
        </CardHeader>
        {renderTrendsSeparator()}
        <CardContent className="p-0 w-full">
          {payload.map((item, index) => (
            <div key={item.name}>
              <div className="flex items-center gap-2 w-full mt-2">
                <div
                  className="size-3"
                  style={{ backgroundColor: colors[item.name] }}
                />
                <span className="text-base-popoverForeground text-p-xs">
                  {item.name}
                </span>
              </div>
              <p className="text-base-popoverForeground text-p-m pt-1">
                {getFormattedValueByType(item.value, metricType)}
              </p>
              {index !== payload.length - 1 && renderTrendsSeparator()}
            </div>
          ))}
        </CardContent>
      </Card>
    );
  }

  return null;
};
